@if (showLabel == true) {
  <label class="container" [ngClass]="{ 'is-invalid': form?.submitted && getName() != null }">
    {{title}}
    <input #cb class="sem-check-box" (ngModelChange)="modelChange($event)" type="checkbox" [(ngModel)]="value" [disabled]="(checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true)" (input)="onChange($event)"  [ngClass]="{'disabled-field': checkForDisabled(getAttribute('name')) }"/>
    <span class="checkmark" [ngClass]="{'disabled-field disabled-cb': (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) }"></span>
  </label>
}

@if (showLabel == false) {
  <input class="sem-check-box" type="checkbox" [(ngModel)]="value" [ngClass]="{'disabled-field': checkForDisabled(getAttribute('name')), 'is-invalid': form?.submitted && getName() != null }" [disabled]="(checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true)"/>
}
